<script lang="ts">
	import { page } from '$app/stores';

	const title = $page.status === 404 ? 'Not found' : `Error ${$page.status}`;
	const caption =
		$page.status === 404
			? '🤔 I can not find this...<br>Are you sure this is the right URL?'
			: '💥 Something went wrong';
</script>

<svelte:head>
	<title>{title}</title>
</svelte:head>

<section class="flex flex-col content-center items-center px-8">
	<h1 class="mt-8 text-4xl" data-testid="error-caption">
		{@html $page.status === 404 && $page.error?.message
			? $page.error?.message // show 404 messages directly here
			: $page.status === 404
				? 'Diese Seite kann ich leider nicht finden. <br>🤔 Bist du sicher das die URL richtig ist?'
				: '💥 Etwas ist schief gelaufen'}
	</h1>
	<div class="max-w-xl sm:max-w-5xl">
		{#if $page.error?.message && $page.status !== 404}
			<div>
				<pre class="mt-4 text-xs">{$page.error?.message}</pre>
			</div>
		{/if}
	</div>
</section>

<style>
</style>
